const formTogglers = document.querySelectorAll('[data-form-toggler]');
const forms =  document.querySelectorAll('[data-form]');

const toggleForm = (activeForm) => {
    forms.forEach((form) => {
        form.classList.add('d-none');
    });

    forms.forEach((form) => {
        if (form.getAttribute('data-form') === activeForm) {
            form.classList.remove('d-none');
        }
    })
}

if (formTogglers && forms) {
    formTogglers.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            toggleForm(toggle.getAttribute('data-form-toggler'));
        });
    });
}

window.addEventListener('load', () => {
    formTogglers.forEach((toggle) => {
        if (toggle.checked) {
            toggleForm(toggle.getAttribute('data-form-toggler'));
        }
    });
});
